import { Stack } from 'expo-router';
import React from 'react';

import HeaderButton from '@molecules/HeaderButton';
import type { DrawerNavigationProp } from '@react-navigation/drawer';
import { defaultBack } from '@utils/navigation';

import { Menu01Icon, PlusSignIcon } from '@hugeicons/core-free-icons';
import { headerOptionsCreator } from '@utils/screenOptions';
import { router } from 'expo-router';

export default function Layout() {
  return (
    <Stack>
      <Stack.Screen
        name="index"
        options={headerOptionsCreator(
          <HeaderButton<DrawerNavigationProp<never>>
            icon={Menu01Icon}
            onPress={(_, navigation) => {
              navigation.openDrawer();
            }}
          />,
          <HeaderButton
            icon={PlusSignIcon}
            onPress={() => {
              router.navigate('/introduce');
            }}
          />,
        )}
      />
      <Stack.Screen
        name="[introId]"
        options={headerOptionsCreator(
          <HeaderButton onPress={defaultBack('/intros/myIntros/denied')} />,
        )}
      />
    </Stack>
  );
}
